import { gql } from "@apollo/client";

export const createPasswordRecoveryRequestQuery = gql`
    mutation CreatePasswordRecoveryRequest($email: String!) {
        createPasswordRecoveryRequest(email: $email) 
    }
`;
